export const environment = {
    production: true,
    environmentName: "Test",

    gcConnectorUrl: "https://greencommerce-connector-testomgeving.azurewebsites.net/api/",
    identityServerUrl: "https://jemid-identityserver-testomgeving.azurewebsites.net",
    appUrl: "https://greencommerce-connector-portal-testomgeving.azurewebsites.net",
    clientId: "7a5e29ca-aff2-44b3-9531-334c2340b296",
};
